module.exports = __webpack_public_path__ + "static/img/img_logo.ceb12fa8.png";